import { useRef } from 'react';
import { UseQueryOptions, QueriesOptions, QueriesResults, useQueries } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSettledQueries = <T extends any[]>(arg: {
    queries: readonly [...QueriesOptions<T>];
    context?: UseQueryOptions['context'];
}): QueriesResults<T> => {
    const result = useQueries<T>(arg);

    const lastResultRef = useRef<QueriesResults<T>>();
    const isSettled = !result.some((r) => r.fetchStatus !== 'idle');

    return isSettled ? (lastResultRef.current = result) : lastResultRef.current ?? result;
};
